<div class="banner" *ngIf="visible">
  <h2 class="banner-header-1">Пройдите экспресс-оценку </h2>
  <h2  class="banner-header-2">5 шагов за 5 минут </h2>
  <div class="banner-main">
    <div>Оцените готовность к прохождению сертификации</div>
    <button (click)="start()">НАЧАТЬ</button>
  </div>
</div>
<div class="modal" *ngIf="page">
  <div class="modal-window" *ngIf="survey">

    <div class="modal-window-header">
      <h3>Экспресс-оценка</h3>
      <ico (click)="finish()"></ico>
    </div>
    <div class="modal-window-body" [ngSwitch]="page">

      <ng-template class="modal-page" [ngSwitchCase]="1">
        <div class="modal-form-field">
          <div class="modal-form-caption">Вид продукции</div>
          <ex-ev-select-option [list]="productionList" (select)="setProduction($event)" [value]="production"></ex-ev-select-option>
        </div>
      </ng-template>
      <ng-template ngSwitchDefault></ng-template>

      <ng-template class="modal-page" [ngSwitchCase]="2">
        <div class="modal-form-field">
          <div class="modal-form-caption">Пройдены ли необходимые процедуры обязательного подтверждения соответствия</div>
          <label class="radio"><input type="radio" name="proceeding" [value]="false" [(ngModel)]="proceeding">Нет</label>
          <label class="radio"><input type="radio" name="proceeding" [value]="true" [(ngModel)]="proceeding">Да</label>
        </div>
        <div class="advertising">Вы можете <a (click)="sertification()">обратиться</a> в наш орган по обязательной сертификации</div>
      </ng-template>

      <ng-template class="modal-page" [ngSwitchCase]="3">
        <div class="modal-form-field">
          <div class="modal-form-caption">Опыт поставок</div>
          <label class="radio"><input type="radio" name="experience" value="min" [(ngModel)]="experience">Есть опыт поставок на объекты других отраслей</label>
          <label class="radio"><input type="radio" name="experience" value="mid" [(ngModel)]="experience">Есть опыт поставок на объекты нефтегазовых компаний</label>
          <label class="radio"><input type="radio" name="experience" value="max" [(ngModel)]="experience">Есть опыт поставок на объекты ПАО "Газпром"</label>
        </div>
      </ng-template>

      <ng-template class="modal-page" [ngSwitchCase]="4">
        <div class="modal-form-field">
          <div class="modal-form-caption">Наличие сертифицированной системы менеджмента</div>
          <label class="radio"><input type="radio" name="management" value="min" [(ngModel)]="management">Остутсвует</label>
          <label class="radio"><input type="radio" name="management" value="mid" [(ngModel)]="management">По ГОСТ Р ИСО 9001 или иным стандартам</label>
          <label class="radio"><input type="radio" name="management" value="max" [(ngModel)]="management">СТО Газпром 9001</label>
        </div>
        <div class="advertising">Вы можете <a (click)="sertification()">обратиться</a> в наш орган по сертификации систем менеджмента</div>
      </ng-template>

      <ng-template class="modal-page" [ngSwitchCase]="5">
        <div class="modal-form-field">
          <div class="modal-form-caption">Культура производства</div>
          <label class="radio"><input type="radio" name="conditions" value="min" [(ngModel)]="conditions">Наличие технических условий на продукцию</label>
          <label class="radio"><input type="radio" name="conditions" value="mid" [(ngModel)]="conditions">Наличие комплекта КД</label>
          <label class="radio"><input type="radio" name="conditions" value="max" [(ngModel)]="conditions">Наличие протоколов квалификационных/периодических испытаний продукции</label>
        </div>
        <div class="advertising">Вы можете <a (click)="sertification()">обратиться</a> в наш испытательный центр</div>
      </ng-template>

      <ng-template ngSwitchDefault></ng-template>
    </div>
    <div class="modal-window-footer">
      <button class="outline" (click)="page=page-1">НАЗАД</button>
      <span class="sm-hide">Шаг {{page}} из 5</span>
      <span class="lg-hide">{{page}}/5</span>
      <button (click)="nextPage()">{{page<5?'ДАЛЕЕ':'ОЦЕНИТЬ'}}</button>
    </div>

  </div>



  <div class="modal-window" *ngIf="final">
    <div class="modal-window-header">
      <h3>Экспресс-оценка</h3>
      <ico (click)="finish()"></ico>
    </div>
    <div class="modal-window-body">
      <div>Оценка проведена успешно.</div>
      <div>Степень готовности к прохождению сертификации:</div>
      <div [ngStyle]="summaryStyle" class="summaryStyle">
        <div>
          <h3>{{summary}}%</h3>
        </div>
      </div>
      <div>Вы можете подать заявку в орган по сертификации онлайн или получить консультацию специалиста по телефону.</div>
    </div>
    <div class="modal-window-footer modal-window-footer-final">
      <button (click)="sertification()">ПОДАТЬ ЗАЯВКУ</button>

    </div>
  </div>

  <div class="modal-window" *ngIf="application">
    <div class="modal-window-header">
      <h3>Запрос консультации специалиста</h3>
      <ico (click)="finish()"></ico>
    </div>
    <div class="modal-window-body">
      <div class="modal-form-field">
        <label class="modal-form-caption" for="req-company">Наименование организации:</label>
        <input [(ngModel)]="applicant.company" name="req-company" required>
      </div>
      <div class="modal-form-field">
        <label class="modal-form-caption" for="req-fcs">Фамилия Имя Отчество:</label>
        <input [(ngModel)]="applicant.fcs" name="req-fcs" required>
      </div>
      <div class="modal-form-field">
        <label class="modal-form-caption" for="req-phone">Телефон:</label>
        <input class="modal-form-w50" [(ngModel)]="applicant.phone" name="req-phone" required>
      </div>
      <div class="modal-form-field">
        <label class="modal-form-caption" for="req-email">e-mail:</label>
        <input class="modal-form-w50" type="email" [(ngModel)]="applicant.email" name="req-email" required>
      </div>
    </div>
    <div class="modal-window-footer modal-window-footer-final">
      <button  (click)="mail()" [disabled]="!applicantComplete">ОТПРАВИТЬ</button>
    </div>
  </div>

  <div class="modal-window" *ngIf="userResp">
    <div class="modal-window-header">
      <h3>Сообщение отправленно</h3>
      <ico (click)="finish()"></ico>
    </div>
    <div class="modal-window-body">
      Благодарим за обращение. Ваше сообщение отправлено специалистам СЦ&nbsp;ВНИИГАЗ-Сертификат. Эксперт свяжется с вами в течении двух рабочих дней и предоставит вам исчерпывающую консультацию по прохождению сертификации.
    </div>
    <div class="modal-window-footer modal-window-footer-final">
      <button  (click)="finish()" [disabled]="!applicantComplete">ЗАКРЫТЬ</button>
    </div>
  </div>

</div>